import type { AwsHealthMonitorResults } from '@internal/plugin-aws-health-monitor-common';
import type { AwsHealthMonitorApi } from './types';
import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export class AwsHealthMonitorClient implements AwsHealthMonitorApi {
  constructor(
    private readonly options: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  async getHealthMonitorResults(): Promise<AwsHealthMonitorResults> {
    const baseUrl = await this.options.discoveryApi.getBaseUrl(
      'aws-health-monitor',
    );

    const response = await this.options.fetchApi.fetch(
      `${baseUrl}/aws-health-monitor`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      },
    );

    if (!response.ok) {
      throw new Error(
        `AWS Health Monitor request failed: ${response.status} ${response.statusText}`,
      );
    }

    return response.json();
  }
}
